import React, { Component } from "react";
import "./style/header.css";

class Header extends Component {
  render() {
    return (
      <div className="header-wrapper">
        <header>
          <hgroup>
            <h1>
              <a href="#main">Tambour Korps "Blau-Weiß" Hartegasse</a>
            </h1>
            <h3>Tambour Korps "Blau-Weiß" Hartegasse</h3>
          </hgroup>
          <nav>
            <ul>
              <li>
                <a href="#main">Start</a>
              </li>
              <li>
                <a href="#jugend">Jugendarbeit</a>
              </li>
              <li>
                <a href="#chronik">Chronik</a>
              </li>
              <li>
                <a href="#calendar">Kalender</a>
              </li>
              <li>
                <a href="#gallery">Gallerie</a>
              </li>
              <li>
                <a href="#contact">Kontakt</a>
              </li>
              <li>
                <a href="#about-us">Impressum</a>
              </li>
            </ul>
          </nav>
        </header>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js